import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  static targets = ["countrySelect", "institutionSelect", "status", "submit"];

  declare readonly hasCountrySelectTarget: boolean;
  declare readonly countrySelectTarget: HTMLSelectElement;
  declare readonly countrySelectTargets: HTMLSelectElement[];

  declare readonly hasInstitutionSelectTarget: boolean;
  declare readonly institutionSelectTarget: HTMLSelectElement;
  declare readonly institutionSelectTargets: HTMLSelectElement[];

  declare readonly statusTarget: HTMLElement;
  declare readonly submitTarget: HTMLButtonElement;

  connect() {
    this.update();
  }

  update() {
    const countryId = this.countrySelectTarget.value;
    this.showInstitutionsForCountry(countryId);
    const active = this.institutionSelectTargets.find((select) => !select.disabled);
    const count = active ? active.options.length - 1 : 0;
    this.statusTarget.textContent = !active
      ? "Choose a country to see available banks."
      : count === 0
        ? "No banks are available for this country. Choose another country or create a manual account."
        : `${count} ${count === 1 ? "bank available" : "banks available"}. Choose your bank from the list.`;
    this.submitTarget.disabled = !active || !active.value;
  }

  showInstitutionsForCountry(countryCode: string) {
    const institutionsSelects = this.institutionSelectTargets;
    institutionsSelects.forEach((institutionSelect) => {
      const selected = institutionSelect.dataset.countryCode === countryCode;
      institutionSelect.hidden = !selected;
      institutionSelect.disabled = !selected;
    });
  }
}
